import { useState } from 'react'

import { Body } from './components/Body'
import { DevPreferencesTester } from './components/DevPreferencesTester'
import { DynamicLoadsCfTester } from './components/DynamicLoadsCfTester'
import { ErrorTester } from './components/ErrorTester'
import { MapTesters } from './components/MapTesters'
import { PolylineTester } from './components/PolylineTester'
import { RouteManagerVersionTester } from './components/RouteManagerVersionTester'
import { ServerDataEndpoints } from './components/ServerDataEndpoints'
import { TagsTester } from './components/TagsTester/TagsTester'
import { TelematicsTesters } from './components/TelematicsTesters'
import { VirtualDevices } from './components/VirtualDevices'

import { useOptions } from './hooks/useOptions'

export type Tab =
  | 'map'
  | 'scheduler'
  | 'tagsField'
  | 'devPreferences'
  | 'poly'
  | 'error'
  | 'version'
  | 'virtualDevices'
  | 'dynamicLoadsCf'
  | 'newScheduler'
  | 'telematics'
  | 'serverDataEndpoints'

export function TesterModal() {
  const [tab, setTab] = useState<Tab>('devPreferences')
  const options = useOptions(tab)

  return (
    <Body options={options} setTab={setTab} tab={tab}>
      {tab === 'map' && <MapTesters />}
      {tab === 'poly' && <PolylineTester />}
      {tab === 'devPreferences' && <DevPreferencesTester />}
      {tab === 'error' && <ErrorTester />}
      {tab === 'version' && <RouteManagerVersionTester />}
      {tab === 'virtualDevices' && <VirtualDevices />}
      {tab === 'dynamicLoadsCf' && <DynamicLoadsCfTester />}
      {tab === 'telematics' && <TelematicsTesters />}
      {tab === 'serverDataEndpoints' && <ServerDataEndpoints />}
      {tab === 'tagsField' && <TagsTester />}
    </Body>
  )
}
